// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".js";
};